import { Component, Input, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  standalone: false,
    selector: 'faro-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutocompleteComponent),
            multi: true,
        },
    ],
})
export class AutocompleteComponent implements ControlValueAccessor {
    @Input()
    label = '';

    @Input()
    suggestionsGetter?: (input: string) => Promise<string[]>;

    @ViewChild('autoComplete')
    private _autoComplete?: AutoComplete;

    private _value = '';

    get value(): string {
        return this._value;
    }

    set value(v: string) {
        if (this._value !== v) {
            this._value = v;
            this.onChange(this._value);
        }
    }

    suggestions: string[] = [];
    focused = false;

    constructor() {}

    writeValue(v: any): void {
        if (v !== undefined) {
            this.value = v;
        }
    }

    onChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    onTouched = () => {};

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    async updateSuggestions(event: any) {
        if (this.suggestionsGetter) {
            this.suggestions = await this.suggestionsGetter(event.query);
        } else {
            this.suggestions = [];
        }
    }

    emphasizeQuery(suggestion: string): string {
        if (!this.value) {
            return suggestion;
        }

        const regExp = new RegExp(this.value, 'gi');
        return `<span>${suggestion.replace(regExp, '<span class="match">$&</span>')}</span>`;
    }

    focusAutoComplete(): void {
        this._autoComplete?.autofocus;
    }
}
